import axiosInstance from '../utils/axiosConfig';

/**
 * Glossary Service — API integration for the IMT Lexicon.
 * Read for all authenticated users; write endpoints require admin (enforced
 * server-side). The viewsets return plain arrays (pagination disabled), but
 * asList() tolerates a paginated {results} shape just in case.
 */
const BASE = '/api/glossary';

const asList = (data) => (Array.isArray(data) ? data : (data && data.results) || []);

const glossaryService = {
    // ===== Reads =====
    getCategories: async () => asList((await axiosInstance.get(`${BASE}/categories/`)).data),
    getTerms: async () => asList((await axiosInstance.get(`${BASE}/terms/`)).data),
    getPermissions: async () => (await axiosInstance.get(`${BASE}/permissions/`)).data,

    // ===== Term CRUD (admin) =====
    createTerm: async (payload) => (await axiosInstance.post(`${BASE}/terms/`, payload)).data,
    updateTerm: async (id, payload) => (await axiosInstance.patch(`${BASE}/terms/${id}/`, payload)).data,
    deleteTerm: async (id) => { await axiosInstance.delete(`${BASE}/terms/${id}/`); },

    // ===== Category CRUD (admin) =====
    createCategory: async (payload) => (await axiosInstance.post(`${BASE}/categories/`, payload)).data,
    updateCategory: async (id, payload) => (await axiosInstance.patch(`${BASE}/categories/${id}/`, payload)).data,
    deleteCategory: async (id) => { await axiosInstance.delete(`${BASE}/categories/${id}/`); },
};

export default glossaryService;
